export type AppId = 'mail' | 'calendar' | 'contacts'
export const appOf = (pathname: string): AppId => (pathname.startsWith('/calendar') ? 'calendar' : pathname.startsWith('/contacts') ? 'contacts' : 'mail')
